// Tab panel block JS - custom element
class TabPanelBlock extends HTMLElement {
  connectedCallback() {
    this._init();
  }

  disconnectedCallback() {
    this._cleanup();
  }

  _init() {
    this._nav = this.querySelector('.tab-panel-block__nav');
    const panels = Array.from(this.querySelectorAll('.tab-panel'));
    const validPanels = panels.filter((panel) => panel.textContent.trim().length > 0);
    this._panels = validPanels;
    panels.filter((panel) => !validPanels.includes(panel)).forEach((panel) => panel.remove());

    if (!this._nav) return;
    if (validPanels.length === 0) {
      this._nav.setAttribute('hidden', '');
      return;
    }

    const blockId = this._getBlockId();

    // Remove existing tab buttons (if reinitializing)
    this._nav.querySelectorAll('.tab-panel-block__tab').forEach((btn) => btn.remove());

    this._panels.forEach((panel, index) => {
      const label = panel.getAttribute('data-tab-label') || 'Tab ' + (index + 1);
      const tabId = 'tab-' + blockId + '-' + index;
      const panelId = 'panel-' + blockId + '-' + index;

      panel.setAttribute('id', panelId);
      panel.setAttribute('aria-labelledby', tabId);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.role = 'tab';
      btn.id = tabId;
      btn.className = 'tab-panel-block__tab';
      btn.setAttribute('aria-controls', panelId);
      btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      btn.textContent = label;

      if (index === 0) {
        btn.classList.add('tab-panel-block__tab--active');
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }

      btn.addEventListener('click', () => this._selectTab(btn, panel));
      this._nav.appendChild(btn);
    });
  }

  _selectTab(activeBtn, activePanel) {
    this._nav.querySelectorAll('.tab-panel-block__tab').forEach((t) => {
      t.classList.remove('tab-panel-block__tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    this._panels.forEach((p) => {
      p.hidden = true;
    });
    activeBtn.classList.add('tab-panel-block__tab--active');
    activeBtn.setAttribute('aria-selected', 'true');
    activePanel.hidden = false;
  }

  _cleanup() {
    if (this._nav) {
      this._nav.querySelectorAll('.tab-panel-block__tab').forEach((btn) => btn.remove());
    }
  }

  _getBlockId() {
    const classMatch = this.className.match(/tab-panel-block--([a-zA-Z0-9_-]+)/);
    return classMatch ? classMatch[1] : Math.random().toString(36).slice(2);
  }
}

if (!customElements.get('tab-panel-block')) {
  customElements.define('tab-panel-block', TabPanelBlock);
}
